import { render } from "./TabTitle.vue?vue&type=template&id=688cfac8"
import script from "./TabTitle.vue?vue&type=script&lang=js"
export * from "./TabTitle.vue?vue&type=script&lang=js"
script.render = render

export default script